function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M39.596 4.065A13.52 13.52 0 0 0 22 2.75 13.52 13.52 0 0 0 4.404 23.19L20.47 39.255a2.158 2.158 0 0 0 3.062 0l16.065-16.064a13.518 13.518 0 0 0 0-19.126Zm-3.04 16.086L22 34.684 7.445 20.15a9.229 9.229 0 0 1 6.469-15.74 9.164 9.164 0 0 1 6.468 2.695 2.155 2.155 0 0 0 3.062 0A9.207 9.207 0 0 1 36.383 20.15h.172Z",
  fill: "#F2F2F2"
});

function SvgIconCoracao({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 40,
    viewBox: "0 0 44 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCoracao);
export default __webpack_public_path__ + "static/media/icon-coracao.8acffcb4d968d877cad42681a32accd6.svg";
export { ForwardRef as ReactComponent };